import { connect } from "react-redux";
import ValetTransactionList from "./ValetTransactionList";
import { bindActionCreators } from "redux";
import { lastFiveTransactionListing } from "services/redux/valetIncentive/action";
const mapStateToProps = (state) => ({
    lastFiveTransactionsList: state.ValetIncentive.lastFiveTransactionsList
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        lastFiveTransactionListing
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ValetTransactionList);
